export default __webpack_public_path__ + "static/nj-web-dcf453963fc2a20958c3620507f43e30.png";